const accessControlTutorial = {
  module: 'access_control',
  moduleName: 'Access Control',
  steps: [
    {
      target: '.page-title',
      position: 'bottom',
      title: 'Access Control',
      description: 'Manage doors, readers, and access events from all your connected systems.',
    },
    {
      target: '.lockdown-bar',
      position: 'bottom',
      title: 'Emergency Lockdown',
      description: 'One-click lockdown for all doors in an emergency situation.',
    },
    {
      target: '.acs-vendor-badge',
      position: 'bottom',
      title: 'Multi-Vendor',
      description: 'See which access control system is connected for this site.',
    },
  ],
};

export default accessControlTutorial;
